module.exports = __webpack_public_path__ + "6dfc242ce6ea82216552d32683a6f616.png";